<template>
	<div>
		<div class="modal fade" id="anexarImagemModalId" data-backdrop="static">
			<div
				class="modal-dialog modal-sm"
				style="width: 500px !important"
				role="document"
			>
				<div class="modal-content">
					<div class="modal-header">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 class="modal-title" id="myModalLabel">
							Anexar Imagem
						</h4>
					</div>

					<div v-if="loading" class="modal-body">
						<i data-v-4481e0c6="" class="fa fa-spin fa-spinner"></i>
						Carregando...
					</div>

					<div v-else class="modal-body">
						<div
							style="
								display: flex;
								margin-bottom: 15px;
								justify-content: space-between;
							"
						>
							<div v-if="data.anexo">
								<a
									target="_blank"
									:href="data.anexo"
									class="btn-upload-image"
								>
									Ver imagem anexada
									<i class="fa fa-upload"></i>
								</a>
							</div>

							<div>
								<label
									class="form-control--no-padding"
									for="inputTag"
								>
									<div class="btn-upload-image">
										Anexar imagem
										<i class="fa fa-upload"></i>
									</div>
									<!-- v-model="data.anexo" -->
									<div class="file">
										<input
											type="file"
											multiple="false"
											class="inputTag"
											accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .svg, .pdf, .tiff|image/*"
											v-on:change="
												handleUploadImage($event)
											"
											id="inputTag"
										/>
									</div>
								</label>
							</div>
						</div>
						<div class="modal-footer">
							<button
								type="button"
								class="btn btn-default"
								data-dismiss="modal"
							>
								<i class="fa fa-close"></i> Cancelar
							</button>
							<aBtn
								action="private-save-vacinas"
								@click="save"
								text="Salvar"
								icon="save"
								type="primary"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	/*

  id precisa existir para poder ocorrer a criação

  */
	import clone from 'js/clone';
	import aBox from 'box';
	import aBtn from 'btn';
	import WBS from 'js/http';
	import toastr from 'toastr';
	import moment from 'moment';
	import { mask } from 'vue-the-mask';
	import axios from 'axios';

	let reset = {
		data: {},
		anexo: '',
	};

	export default {
		name: 'ChModalVacinas',
		components: { aBox, aBtn, mask, axios },
		data() {
			return {
				data: {
					moment: moment,
					...clone(reset),
				},

				loading: false,
			};
		},
		methods: {
			handleUploadImage(e) {
				const file = e.target.files[0];

				console.log(file);

				console.log('this.data.anexo');
				console.log(this.data.anexo);

				console.log(file.name);
				console.log(file.name);

				const fileName = file.name.replace(/ /g, '');

				//renaming file
				var blob = file.slice(0, file.size, file.type);
				const updatedFile = new File([blob], fileName, {
					type: file.type,
				});

				console.log('-*-*-*-*-*');
				console.log('updatedFile');
				console.log(updatedFile);

				this.uploadImage(updatedFile);
			},

			async uploadImage(file) {
				const backendUrl = 'http://viamed.ddns.net:3000';

				const formData = new FormData();
				formData.append('file', file);

				const uploadedImageUrl = await axios
					.post(`${backendUrl}/upload`, formData, {
						headers: {
							Accept: 'application/json',
							'Content-Type': 'multipart/form-data',
							'Access-Control-Allow-Origin': '*',
						},
					})
					.then(() => `${backendUrl}/uploads/${file.name}`);
				this.data.anexo = uploadedImageUrl;
			},

			async open(data = null) {
				if (data != null) {
					this.loading = true;

					await WBS.send(
						'private-custom-vacinasFind',
						data,
						(resp) => {
							if (resp.status == 'success') {
								this.data = resp.data;
								this.loading = false;
							} else {
								toastr.error(resp.msgs[0]);
								console.log(this.data);
							}
						}
					);

					// data.vencimento_vacina     = this.handleParseDateTimeToString(data.vencimento_vacina)

					this.data = clone(data);
				} else this.data = clone(reset);
				$('#anexarImagemModalId').modal('show');
			},

			async save() {
				await WBS.send('private-save-vacinas', this.data, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Documento anexado com sucesso!');
						this.$emit('update');
						$('#anexarImagemModalId').modal('hide');
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
						console.log(this.data);
					}
				});
			},
		},

		mounted() {},
	};
</script>

<style>
	span {
		text-transform: uppercase;
	}

	.file {
		display: none;
	}

	.image-upload {
		width: 30vw;
		height: 30vw;
		border-radius: 1px;
		border: 1px solid #d2d6de;
		object-fit: cover;
	}

	label {
		font-weight: normal;
		text-transform: uppercase;
	}

	.link {
		text-transform: none;
	}

	.link:hover {
		filter: contrast(200%);
	}

	.link--active {
		text-transform: none;
		color: #333;
	}

	.link--inactive {
		color: #ccc !important;
	}

	.btn-upload-image {
		text-transform: none;

		background-color: #d35c32 !important;

		color: white;

		border-radius: 3px;
		-webkit-box-shadow: none;
		box-shadow: none;
		border: 1px solid transparent;

		padding: 6px 12px;

		font-size: 14px;

		-webkit-box-shadow: none;
		box-shadow: none;

		display: inline-block;
		padding: 6px 12px;
		font-size: 14px;
		font-weight: 400;
		line-height: 1.42857143;
		text-align: center;
		white-space: nowrap;
		vertical-align: middle;
		-ms-touch-action: manipulation;
		touch-action: manipulation;
		cursor: pointer;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		background-image: none;
		/* border: 1px solid #ccc; */
		border-radius: 4px;
	}

	.fa,
	.fa-spin,
	.fa-spinner {
		overflow: visible !important;
	}

	.upload-container {
		display: flex;
		flex-direction: column;
	}

	.flex-container {
		display: flex;
		gap: 10px;
		margin: 0 !important;
	}

	.flex-container__item__upload-container__flex-item {
		display: flex;
		gap: 10px;
		align-items: center;
		/* width: 100%; */
		width: 30%;
	}

	.form-control--no-padding {
		padding: 0;
		margin: 0;
	}

	.button-link {
		text-decoration: none !important;
		display: inline-block;

		text-transform: none;

		background-color: #e97f59 !important;

		color: white !important;

		font-size: 14px;

		-webkit-box-shadow: none;
		box-shadow: none;

		font-size: 14px;
		font-weight: 400;
		line-height: 1.42857143;
		text-align: center;
		white-space: nowrap;
		vertical-align: middle;
		-ms-touch-action: manipulation;
		touch-action: manipulation;
		cursor: pointer;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		background-image: none;
		/* border: 1px solid #ccc; */
		border-radius: 4px;
	}
</style>



// WEBPACK FOOTER //
// src/components/cadastros/vacinas/anexarImagemModal.vue